var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFileOffline = function SvgFileOffline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.57 18.568a5.815 5.815 0 0 0-.474-5.303 5.5 5.5 0 0 0-1.956-1.848 5.266 5.266 0 0 0-2.568-.667h-1.366a9.053 9.053 0 0 0-2.785-4.639A8.514 8.514 0 0 0 10.562 4M5.477 5.125a8.892 8.892 0 0 0-3.784 4.35 9.314 9.314 0 0 0-.4 5.844 9.022 9.022 0 0 0 3.152 4.862 8.467 8.467 0 0 0 5.369 1.818h9.758c.629 0 1.253-.115 1.844-.338M2.5 1.5 24 23",
    stroke: "#8B8C8E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFileOffline;